import React from "react";
import './slimHeader.scss';
import { LogoIcon } from "../svgs/LogoIcon";

export const SlimHeader = () => (
    <header>
        <nav className="navbar navbar-default navbar-fixed-top">
            <div className="container-fluid">
                <div className="navbar-header">
                    <div className="navbar-brand">
                        <LogoIcon/>
                    </div>
                </div>
            </div>
        </nav>
    </header>
);

